export default "__VITE_ASSET__8b103bce__"